import { createContext } from "react";

export const ModalRenderProps = createContext(null);
